import { WithLoader } from '@/providers/WithLoader';
import { WithRedux } from '@/providers/WithRedux';
import '@/styles/globals.scss';
import type { AppProps } from 'next/app';
import Head from 'next/head';
import { SessionProvider } from 'next-auth/react';
import { Toaster } from 'react-hot-toast';
import { useEffect } from 'react';

export default function App({
  Component,
  pageProps: { session, ...pageProps },
}: AppProps) {
  useEffect(() => {
    // Окончательно удаляем товары, которые были помечены для удаления
    try {
      const deletedItemsData = localStorage.getItem('DELETED_CART_ITEMS');
      if (deletedItemsData) {
        const deletedItems = JSON.parse(deletedItemsData);

        // Удаляем товары из локальной корзины
        const localCartData = localStorage.getItem('LOCAL_CART');
        if (localCartData && deletedItems.length > 0) {
          let localCart = JSON.parse(localCartData);

          deletedItems.forEach((deletedItem: any) => {
            if (deletedItem.isLocal) {
              localCart = localCart.filter((cartItem: any) => {
                const isDifferentGood = cartItem.good !== deletedItem.goodId;
                const isDifferentOptions =
                  JSON.stringify(cartItem.additionalOptions) !==
                  JSON.stringify(deletedItem.additionalOptions);
                return isDifferentGood || isDifferentOptions;
              });
            }
          });

          localStorage.setItem('LOCAL_CART', JSON.stringify(localCart));

          // Отправляем событие об изменении корзины
          window.dispatchEvent(new Event('localCartChanged'));
        }
      }

      // Очищаем список удаленных товаров
      localStorage.removeItem('DELETED_CART_ITEMS');
    } catch (error) {
      console.error('Error processing deleted items:', error);
    }

    const handlePopState = () => {
      if (window.location.href.includes('/catalog')) {
        window.location.reload();
      }
    };

    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  return (
    <>
      <Head>
        <title>Zeta</title>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Head>
      <SessionProvider session={session}>
        <WithRedux>
          <WithLoader>
            <Component {...pageProps} />
            <Toaster
              toastOptions={{
                success: {
                  duration: 5000,
                  iconTheme: {
                    primary: '#ad1918',
                    secondary: '#ffffff',
                  },
                },
                error: {
                  duration: 5000,
                },
              }}
            />
          </WithLoader>
        </WithRedux>
      </SessionProvider>
    </>
  );
}
